import React, { useState, useEffect } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const AffiliateBanner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      icon: "🎁",
      iconClass: "animate-bounce",
      badge: "AutoWork Affiliate",
      badgeColor: "text-yellow-400",
      title: "Nhận hoa hồng 30% trọn đời trong 1 năm.",
      slogan: '"Trao Giải Pháp Hay, Nhận Ngay Thu Nhập 🚀"',
      buttonText: "Tham Gia Ngay",
      bgColor: "from-blue-950 via-blue-900 to-blue-950",
      action: () => {
        const userAccessToken = localStorage.getItem("userAccessToken");
        if (userAccessToken) {
          window.location.href = "/affiliate";
        } else {
          window.location.href = "/login?redirect=/affiliate";
        }
      },
    },
    {
      icon: "⚡",
      iconClass: "animate-pulse text-yellow-300",
      badge: "Dùng Thử Premium",
      badgeColor: "text-cyan-400",
      title:
        "Nhận 1 ngày Premium miễn phí & điểm AI tạo và đăng bài viết tự động!",
      slogan: '"Trải nghiệm cao cấp, bứt phá doanh số 🚀"',
      buttonText: "Trải Nghiệm Ngay",
      bgColor: "from-slate-900 via-slate-800 to-slate-900",
      action: () => {
        const userAccessToken = localStorage.getItem("userAccessToken");
        if (userAccessToken) {
          window.location.href = "/auto-post";
        } else {
          window.location.href = "/login?signup=true";
        }
      },
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const activeSlide = slides[currentSlide];

  return (
    <div
      className={`bg-gradient-to-r ${activeSlide.bgColor} text-white relative z-40 overflow-hidden shadow-md pt-[64px] transition-colors duration-1000 ease-in-out`}
    >
      {/* Background patterns */}
      <div className="absolute inset-0 opacity-10 pointer-events-none z-0">
        <div className="absolute -top-10 -right-10 w-32 h-32 bg-yellow-400 rounded-full blur-2xl"></div>
        <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-blue-400 rounded-full blur-2xl"></div>
      </div>

      {/* Slider Container */}
      <div className="w-full overflow-hidden relative z-10">
        <div
          className="flex transition-transform duration-500 ease-in-out w-full"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((slide, index) => (
            <div key={index} className="w-full flex-shrink-0">
              <div className="container mx-auto px-12 py-3.5">
                <div className="flex flex-col lg:flex-row items-center justify-center gap-3 lg:gap-6 text-center lg:text-left min-h-[44px]">
                  <div className="flex items-center gap-2">
                    <span className={`text-2xl ${slide.iconClass}`}>
                      {slide.icon}
                    </span>
                    <div className="text-sm lg:text-base font-medium">
                      <span className={`${slide.badgeColor} font-bold mr-1.5`}>
                        {slide.badge}:
                      </span>
                      {slide.title}
                    </div>
                  </div>

                  <div className="hidden lg:block w-px h-6 bg-blue-400/30"></div>

                  <div className="hidden lg:block text-xs lg:text-sm text-blue-100 font-semibold italic">
                    {slide.slogan}
                  </div>

                  <button
                    onClick={slide.action}
                    className="mt-2 lg:mt-0 whitespace-nowrap bg-yellow-400 hover:bg-yellow-300 text-blue-900 text-xs lg:text-sm font-bold py-1.5 px-4 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5 active:scale-95"
                  >
                    {slide.buttonText}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-3 md:left-5 top-[calc(50%+32px)] transform -translate-y-1/2 w-8 h-8 md:w-9 md:h-9 rounded-full bg-black/30 hover:bg-black/50 border border-white/10 backdrop-blur-sm flex items-center justify-center text-white/70 hover:text-white transition-all z-20 shadow-md hover:scale-105 active:scale-95"
        aria-label="Previous slide"
      >
        <FiChevronLeft className="text-lg md:text-xl" />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-3 md:right-5 top-[calc(50%+32px)] transform -translate-y-1/2 w-8 h-8 md:w-9 md:h-9 rounded-full bg-black/30 hover:bg-black/50 border border-white/10 backdrop-blur-sm flex items-center justify-center text-white/70 hover:text-white transition-all z-20 shadow-md hover:scale-105 active:scale-95"
        aria-label="Next slide"
      >
        <FiChevronRight className="text-lg md:text-xl" />
      </button>

      {/* Dots Indicator */}
      <div className="absolute bottom-1.5 left-1/2 transform -translate-x-1/2 flex gap-1.5 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${currentSlide === index ? "bg-white scale-125" : "bg-white/30"}`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default AffiliateBanner;
